const storageKey = (farmId) => `service-order-machine-groups-${farmId}`;

export function loadServiceOrderMachineGroups(farmId) {
  if (!farmId) return [];
  try {
    const raw = localStorage.getItem(storageKey(farmId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}

export function saveServiceOrderMachineGroups(farmId, groups) {
  if (!farmId) return;
  localStorage.setItem(storageKey(farmId), JSON.stringify(groups || []));
}

export function createMachineGroupId() {
  return `group-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}
